import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import {Link, useHistory} from "react-router-dom";

import NotificationDate from "./components/NotificationDate";
import NotificationContentHeader from "./components/NotificationContentHeader";

import {markAsRead} from "api/notification/update";
import deleteNotification from "api/notification/delete";

import {black400, grey300, greyishBlue100} from "assets/jss/main";

import {MarketplaceRoutes} from "utils/MarketplaceRoutes";
import {OMSRoutes} from "utils/OMSRoutes";

import {NOTIFICATION_TYPE} from "../../../../index";
import {SidebarContext} from "../../../../../../../../../../SidebarContext";
import {Divider} from "@mui/material";

NotificationContent.propTypes = {
    notification: PropTypes.object
};

function NotificationContent({notification = null}) {
    const [isHovered, setIsHovered] = useState(false);

    const {isMobile, closeSidebar} = useContext(SidebarContext);

    const history = useHistory();

    if (!notification) {
        return null;
    }

    function getNotificationLink() {
        const content = notification.content;
        const values = content.values;

        if (notification.type === NOTIFICATION_TYPE.IMPORT) {
            const retailer = values.retailer;

            if (
                content.message === "notification.import.error.detail"
                && values.id
            ) {
                return MarketplaceRoutes.RETAILER_FEEDS_HISTORY(retailer, values.id)
            } else if (values.importing === false) {
                return MarketplaceRoutes.RETAILER_PRODUCTS_LIST(retailer);
            }
        } else if (notification.type === NOTIFICATION_TYPE.QUOTE) {
            return OMSRoutes.QUOTE(values.quoteId);
        } else {
            return null;
        }
    }

    function handleClick(e) {
        if (e.metaKey || e.ctrlKey) {
            return;
        }

        const notificationLink = getNotificationLink();
        const action = notification.viewed ? deleteNotification : markAsRead;

        action(notification).then(() => notificationLink && history.push(notificationLink));
    }

    const notificationLink = getNotificationLink();

    const content = (
        <div
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={(e) => {
                e.stopPropagation();
                handleClick(e);
                closeSidebar();
            }}
            style={{
                display: 'flex',
                flexDirection: 'column',
                padding: isMobile ? '10px 8px' : '24px 20px',
                fontSize: '14px',
                cursor: 'pointer',
                background: isHovered ? grey300 : '#FFF',
            }}
        >
            <Divider />
            <NotificationContentHeader isHovered={isHovered} notification={notification} />
            <div style={{
                color: black400,
                overflow:'hidden',
                marginTop: '16px',
                marginBottom: '8px',
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: '3'
            }}>
                <FormattedMessage id={notification.content.message} values={notification.content.values}/>
            </div>
            <NotificationDate notification={notification} />
        </div>
    );

    if (notificationLink) {
        return (
            <Link to={notificationLink} style={{ textDecoration: 'none', color: 'inherit' }}>
                {content}
            </Link>
        )
    }

    return content;
}

export default NotificationContent;
